module.exports = __webpack_public_path__ + "img/Case_Study_Image_1.e16db38f.jpg";